package link.erpango.quip.data.remote

enum class DBackendError {
    UNKNOWN,
}

sealed class DResponse<out T> {
    class Success<out T>(val data:T): DResponse<T>()
    class Complete(val message:String?=null):DResponse<Nothing>()

    /**
     * @param statusCode código HTTP cuando el error viene de una respuesta 4xx/5xx.
     * @param body cuerpo crudo de esa respuesta, para endpoints que devuelven datos útiles en
     * un error (p. ej. el 409 de transferencias con la transferencia ya activa).
     */
    class Error(
        val error:String?=null,
        val throwable: Throwable?=null,
        val statusCode: Int? = null,
        val body: String? = null,
    ): DResponse<Nothing>() {
        fun manageBackendErrorMessage(): DBackendError {
            return error?.let {
                when {
                    else -> DBackendError.UNKNOWN
                }
            } ?: DBackendError.UNKNOWN
        }
    }
}